import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Route } from '../interfaces/route';
import { MessageService } from '../services/message.service';
const directionsUrl = "assets/json/directions.json";

@Injectable({
  providedIn: 'root'
})
export class RouteDirectionsService {

  constructor( private http: HttpClient,
    private messageService: MessageService) {

  }

  get (route: string): Observable<any[]> {
    return this.http.get(directionsUrl)
      .pipe(
        map ((array: any) => array = this.transform(array, route)),
        tap (_ => this.log('fetched routes')),
        catchError (this.handleError<Route[]>('get', []))
      );
  }

  private transform(reponse: any, route: string): any{
    var directions: any = [];

    for(const routes of reponse){
      if(routes.Route == route){
        directions.push(routes);
      }
    }

    return directions;
  }
  
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<any> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      //Load the stored routes.json show no data message.
      return of(result as T);
    };
  }

    /** Log a RouteService message with the MessageService */
    private log(message: string) {
      this.messageService.add(`RouteService: ${message}`);
    }
}
